export default {
  name: 'border',
  type: 'layout',
  active: false,
  data: {
    style: 'solid',
    color: ''
  }
}
